import { Dialog } from '@mui/material';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import TextInput from '@Components/DomElements/TextInput';
import {
    ModalBody,
    ModalFooter,
    ModalHeader,
} from '@Components/ModalComponents';
import { IProject, IUpdateProject } from '@Data/projects/Interfaces';
import TeamsApi from '@Data/teams/Api';
import { teamMembersState } from '@Data/teams/Reducer';
import { IUser } from '@Data/users/Interfaces';
import Roles from '../../HomeViewRoles';
import Styles from './ManageProject.scss';

export enum ManageProjectType {
    CREATE,
    EDIT_NAME,
}

interface IManageProjectDialogProps {
    isOpen: boolean;
    onCancel: () => void;
    onSubmit: (
        projectName: string,
        isEdit: boolean,
        onSuccess: () => void
    ) => void;
    projectToEdit: IProject;
    displayType: ManageProjectType;
}

const ManageProjectDialog = (props: IManageProjectDialogProps) => {
    const { isOpen, onCancel, onSubmit, projectToEdit, displayType } = props;

    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [projectName, setProjectName] = useState<string>('');

    useEffect(() => {
        const projectName = !_isNil(projectToEdit)
            ? projectToEdit.project_name
            : '';
        setProjectName(projectName);
    }, [projectToEdit]);

    const handleProjectNameChange = (e) => {
        setProjectName(e.target.value);
    };

    const canSubmit = _isNil(projectToEdit)
        ? projectName !== ''
        : projectName !== '' && projectName !== projectToEdit.project_name;

    const handleSubmit = () => {
        setIsSubmitting(true);
        onSubmit(projectName, !_isNil(projectToEdit), () => {
            setIsSubmitting(false);
            setProjectName('');
        });
    };

    const handleCancel = () => {
        setProjectName('');
        setIsSubmitting(false);
        onCancel();
    };

    let displayName = false,
        title = '';
    switch (displayType) {
        case ManageProjectType.CREATE:
            title = 'Create Project';
            displayName = true;
            break;
        case ManageProjectType.EDIT_NAME:
            title = 'Edit Project Name';
            displayName = true;
            break;
    }

    return (
        <Dialog
            id="manage-project-dialog"
            open={isOpen}
            maxWidth="lg"
            role={
                _isNil(projectToEdit)
                    ? Roles.createProjectDialogue
                    : Roles.editProjectDialogue
            }
            onClose={handleCancel}
        >
            <ModalHeader
                id="manage-project-dialog-header"
                title={title}
                onCancel={handleCancel}
                isCancelDisabled={isSubmitting}
            />
            <ModalBody>
                <div className={Styles.cpMainContainer}>
                    {displayName && (
                        <TextInput
                            id="project-name-input"
                            value={projectName}
                            placeholder={'Project Name'}
                            label={'Project Name'}
                            onChange={handleProjectNameChange}
                            disabled={isSubmitting}
                        />
                    )}

                    {displayType === ManageProjectType.CREATE && (
                        <div style={{ marginBottom: '16px' }} />
                    )}
                </div>
            </ModalBody>
            <ModalFooter
                id="manage-project-dialog-footer"
                onCancel={onCancel}
                onSubmit={handleSubmit}
                canSubmit={canSubmit}
                isSubmitting={isSubmitting}
            />
        </Dialog>
    );
};

export default ManageProjectDialog;
